/**
 * jQuery window `isloaded` special event.
 * 
 * This works for window object only. The difference with 'load' event is that,
 *   binding 'isloaded' after window is loaded will trigger the handler immediately.
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let windowLoadEventObj = null;
  let windowIsLoaded = false;
  let skipSetup = false;

  /**
   * Check if the specified object is a Window
   * 
   * @param {Object} obj 
   * @returns 
   */
  const isWindow = obj => obj !== null && obj === obj.window;

  /**
   * Window onload event handler
   * 
   * @param {Event} ev 
   */
  const windowLoadHandler = (ev) => {
    windowIsLoaded = true;
    windowLoadEventObj = ev;
    trigger(createEvent('isloaded', windowLoadEventObj), window);
  };

  /**
   * Bind to window.onload event
   */
  const setupOnce = () => {
    if (!skipSetup) {
      skipSetup = true;

      window.addEventListener('load', windowLoadHandler, true);
    }
  };

  /**
   * Create event
   * 
   * @param {string} type 
   * @param {Event} origEvent 
   * @returns 
   */
  const createEvent = (type, origEvent) => {
    const e = $.extend(
      new $.Event(),
      origEvent,
      {
        type: type,
        isSimulated: true,
        timeStamp: Date.now()
      }
    );

    return e;
  };

  /**
   * Trigger event on the specified element.
   * 
   * @param {Event} event 
   * @param {HTMLElement} elem 
   */
  const trigger = (event, elem) => {
    $.event.trigger(event, null, elem);
  };

  return () => {
    setupOnce();

    $.event.special.isloaded = {
      // runs on every binding
      add: function(handler) {
        if (isWindow(this)) {
          // already loaded, just trigger the event, 
          //   otherwise windowLoadHandler() will trigger it after window load event
          if (windowIsLoaded) {
            window.setTimeout(() => {
              trigger(createEvent('isloaded', windowLoadEventObj), this);
            });
          }
        }
        else {
          // eslint-disable-next-line no-console
          console.warn('isloaded only works for window object.');
        }
      }
    };
  };

})(jQuery, window);